import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BaseResponseEntity } from 'services/openapi';
import { TransactionIDsQueryKeys } from './constants';
import { UserWalletTransactionService } from 'services/openapi';

export const useTransactionIDBanksQuery = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<BaseResponseEntity, Error, String>({
      mutationFn: (variables: String) => {
        return UserWalletTransactionService.transactionControllerResendTpbTransactions(
          String(variables),
        );
      },
      onSuccess: () =>
        Promise.all([
          queryClient.invalidateQueries([
            TransactionIDsQueryKeys.GET_TRANSACTIONIDS,
          ]),
        ]),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
